import React from "react";
import styles from "./product-header.css";

export interface ProductHeaderProps {
    is_owner_active: boolean;
    is_owner_feed_linkable: boolean;
    designer_url: string;
    owner_name: string;
    short_description: string;
}

function ProductHeader({
    is_owner_active: isOwnerActive,
    is_owner_feed_linkable: isOwnerFeedLinkable,
    designer_url: designerURL,
    owner_name: ownerName,
    short_description: shortDescription,
}: ProductHeaderProps): React.ReactElement {
    return (
        <h1 className={styles.productHeader}>
            <div className={styles.title}>
                {isOwnerActive && isOwnerFeedLinkable ? (
                    <a className={styles.link} href={designerURL}>
                        {ownerName}
                    </a>
                ) : (
                    ownerName
                )}
            </div>

            {shortDescription && <div className={styles.shortDescription}>{shortDescription}</div>}
        </h1>
    );
}

export default ProductHeader;
